import React from "react";
import useSelectedStores from "@lib/hooks/use-selected-stores";
import DashboardBanner from "@components/Banner/DashboardBanner";
import NvrDropdown from "@components/NvrDropdown/NvrDropdown";
import AttributionMenu from "@components/AttributionMenu/AttributionMenu";
import GranularityDropdown from "@components/GranularityDropdown";
import PageLoadingButton from "./PageLoadingButton";
import { DatePicker } from "@components/Datepicker/DatePicker";
import { ComparisonDatePicker } from "@components/Datepicker/ComparisonDatePicker";
import { AccountHealthIndicator } from "./AccountHealthIndicator";

type Props = {
  title: string | React.ReactNode;
  maxDate?: Date;
  minDate?: Date;
  enableCompare?: boolean;
  loading?: boolean;
  onFetchData: () => void;
  showGranularityDropdown?: boolean;
};

export function Header({
  title,
  maxDate,
  minDate,
  loading = false,
  onFetchData,
  showGranularityDropdown = true,
}: Props) {
  const { selectedOrganisation } = useSelectedStores();

  return (
    <>
      <div className="grid items-center relative z-navbar -mx-3 lg:-mx-4 px-3 lg:px-4 bg-background">
        <DashboardBanner key={selectedOrganisation} />
        <div className="w-full flex items-center">
          {typeof title === "string" ? <h2 className="h2">{title}</h2> : title}
          <AccountHealthIndicator />
        </div>
        <div className="mt-4 w-full flex flex-wrap flex-row items-start gap-2">
          <div className="flex-1 lg:max-w-min">
            <NvrDropdown />
          </div>
          <div className="flex-1 lg:max-w-min">
            <AttributionMenu />
          </div>
          <div className="flex-1 lg:max-w-min">
            {showGranularityDropdown && <GranularityDropdown />}
          </div>
          <div className="flex-1 lg:max-w-min lg:ml-auto">
            <DatePicker maxDate={maxDate} minDate={minDate} />
          </div>
          <div className="flex-1 lg:max-w-min">
            <ComparisonDatePicker maxDate={maxDate} minDate={minDate} />
          </div>
          <div className="shrink-0">
            <PageLoadingButton loading={loading} onFetchData={onFetchData} />
          </div>
        </div>
      </div>
    </>
  );
}
